import DatePicker from "react-datepicker";
import Select from 'react-select';
import Switch from "rc-switch";
import {FormUtility} from "../common/FormUtility";
import {SelectUtility} from '../common/SelectUtility';
import {DispatchOrdersUtility} from "../common/DispatchOrdersUtility";
import {ActivityMaterial} from "../../types/ActivityMaterial";
import {Constants} from "../common/Constants";
import {BrokerAssignmentCountInfo} from "./BrokerAssignmentCountInfo";
import {RadioOptionSet} from "../common/RadioOptionSet";
import {SelectOption} from "../common/CommonUIElementTypes";

export let ActivityBrokerAssignmentForm = function (props: any) {
    let activityBrokerAssignment = props.activityBrokerAssignment;
    const formEngine = props.formEngine;
    const fieldIndices = [`activity-${props.activityIndex}`, `activity-broker-assignment-${props.activityBrokerAssignmentIndex}`];

    function getABAFormFieldClasses(classString: string, fieldName: string) {
        return formEngine.getFormFieldClasses(classString, FormUtility.getIndexedFieldName(fieldName, fieldIndices));
    }

    function onChangeActivityBrokerAssignmentValue(fieldName: string, value: any) {
        props.onChangeActivityBrokerAssignmentValue(props.activityIndex, props.activityBrokerAssignmentIndex, fieldName, value);
    }

    function onChangePitHaul(pitHaul: boolean) {
        props.onChangeActivityBrokerAssignmentPitHaul(props.activityIndex, props.activityBrokerAssignmentIndex, pitHaul);
    }

    function forceValueToInteger(fieldName: string) {
        props.forceActivityBrokerAssignmentValueToInteger(props.activityIndex, props.activityBrokerAssignmentIndex, fieldName);
    }

    function forceValueToFloat(fieldName: string) {
        props.forceActivityBrokerAssignmentValueToFloat(props.activityIndex, props.activityBrokerAssignmentIndex, fieldName);
    }

    // The saved assignment embeds its own material, which the active-only supporting data omits once that material is deactivated.
    const savedAssignedActivityMaterial =
        activityBrokerAssignment.assigned_activity_material?.id === activityBrokerAssignment.assigned_activity_material_id ?
            activityBrokerAssignment.assigned_activity_material :
            undefined;

    const assignedActivityMaterial = formEngine.dataStore.data().supportingData.activityMaterials.find(
        (activityMaterial: ActivityMaterial) => activityMaterial.id === activityBrokerAssignment.assigned_activity_material_id
    ) || savedAssignedActivityMaterial;

    const selectableMaterialOptions = DispatchOrdersUtility.selectableMaterialOptionsForScope(
        formEngine.dataStore.data().supportingData.activityMaterials,
        props.activity.activity_scope_id,
        savedAssignedActivityMaterial
    );

    const selectedBrokerOption = SelectUtility.selectOptionForId(
        '' + activityBrokerAssignment.broker_id,
        formEngine.dataStore.data().supportingData.brokerOptions
    );

    const brokerHasEarlierOrEqualOppositeDirectionAssignment = !!selectedBrokerOption &&
        DispatchOrdersUtility.brokerHasEarlierOrEqualOppositeDirectionAssignment(
            activityBrokerAssignment,
            props.activity,
            formEngine.dataStore.data().activities || []
        );

    return (
        <div className="activity-broker-assignment-form">
            <div className="common-form-body-row assignment-row">
                <div className="common-form-body-row-horizontal">
                    <div className="common-form-body-row-horizontal-cell broker">
                        <div className={getABAFormFieldClasses("common-form-field", "broker_id")}>
                            <div className="common-form-field-label">
                                {props.activityBrokerAssignmentIndex > 0 ?
                                    `Assign Broker #${props.activityBrokerAssignmentIndex + 1}` :
                                    'Assign Broker'
                                }
                            </div>
                            <div className="common-form-field-input-container">
                                <Select
                                    className="common-form-select"
                                    classNamePrefix="common-form-select"
                                    value={selectedBrokerOption}
                                    onChange={(option) => onChangeActivityBrokerAssignmentValue('broker_id', option?.value)}
                                    options={formEngine.dataStore.data().supportingData.brokerOptions}
                                />
                            </div>
                            {brokerHasEarlierOrEqualOppositeDirectionAssignment &&
                                <div className="broker-assignment-round-robin-section">
                                    <div className="broker-assignment-round-robin-section-content">
                                        <div className="round-robin-question">
                                            Is this activity a round robin?
                                        </div>
                                        <div className="round-robin-options">
                                            <RadioOptionSet
                                                fieldName="is_round_robin"
                                                wrapperClass="round-robin-option-set"
                                                options={Constants.yesNoSelectOptions}
                                                selectedOption={
                                                    activityBrokerAssignment.is_round_robin ?
                                                        Constants.yesOption :
                                                        Constants.noOption
                                                }
                                                onSelectRadioOption={(fieldName: string, option: SelectOption) => {
                                                    onChangeActivityBrokerAssignmentValue('is_round_robin', option?.value)
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            {selectedBrokerOption &&
                                <BrokerAssignmentCountInfo
                                    dispatchOrderId={formEngine.dataStore.data().id}
                                    selectedBrokerOption={selectedBrokerOption}
                                    date={props.activity.activity_start_time}
                                    knownAssignedTruckCount={props.getKnownAssignedTruckCountForBrokerId(selectedBrokerOption.value)}
                                />
                            }
                        </div>
                    </div>
                    <div className="common-form-body-row-horizontal-cell pit-haul">
                        <div className={getABAFormFieldClasses("common-form-field", "pit_haul")}>
                            <div className="common-form-field-label">
                                Pit Haul
                            </div>
                            <div className="common-form-field-input-container">
                                <div className="pit-haul-switch-container">
                                    <Switch
                                        className="pit-haul-switch"
                                        checked={!!activityBrokerAssignment.pit_haul}
                                        onChange={(checked: boolean) => onChangePitHaul(checked)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="common-form-body-row-horizontal-cell trucks">
                        <div className={getABAFormFieldClasses("common-form-field", "truck_count")}>
                            <div className="common-form-field-label">
                                Trucks
                            </div>
                            <div className="common-form-field-input-container">
                                {activityBrokerAssignment.pit_haul ?
                                    <div className="pit-haul-truck-count-display">+</div> :
                                    <input
                                        id="truck_count"
                                        type="text"
                                        className="common-form-input"
                                        value={activityBrokerAssignment.truck_count}
                                        onChange={(event) => onChangeActivityBrokerAssignmentValue("truck_count", event.target.value)}
                                        onBlur={() => forceValueToInteger("truck_count")}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                    <div className="common-form-body-row-horizontal-cell start-time">
                        <div
                            className={getABAFormFieldClasses("common-form-field start-time-field", "startTimeJsDate")}>
                            <div className="common-form-field-label">
                                Start Time
                            </div>
                            <div className="common-form-field-input-container">
                                <DatePicker
                                    selected={activityBrokerAssignment.startTimeJsDate}
                                    onChange={(date: Date | null) => onChangeActivityBrokerAssignmentValue("startTimeJsDate", date)}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="Time"
                                    dateFormat="hh:mm aa"
                                />
                                <img
                                    src="/static/images/clock-textcolor.svg"
                                    className="common-form-field-right-icon"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="common-form-body-row-horizontal-cell material">
                        <div className={getABAFormFieldClasses("common-form-field", "assigned_activity_material_id")}>
                            <div className="common-form-field-label">
                                Material
                            </div>
                            <div className="common-form-field-input-container">
                                <Select
                                    className="common-form-select"
                                    classNamePrefix="common-form-select"
                                    value={SelectUtility.selectOptionForId(
                                        '' + activityBrokerAssignment.assigned_activity_material_id,
                                        selectableMaterialOptions
                                    )}
                                    onChange={(option) => onChangeActivityBrokerAssignmentValue('assigned_activity_material_id', option?.value)}
                                    options={selectableMaterialOptions}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="common-form-body-row-horizontal-cell amount">
                        <div className={getABAFormFieldClasses("common-form-field", "assigned_material_amount")}>
                            <div className="common-form-field-label">
                                Amount
                            </div>
                            <div className="common-form-field-input-container">
                                <input
                                    id="assigned_material_amount"
                                    type="text"
                                    className="common-form-input"
                                    value={activityBrokerAssignment.assigned_material_amount}
                                    onChange={(event) => onChangeActivityBrokerAssignmentValue("assigned_material_amount", event.target.value)}
                                    onBlur={() => forceValueToFloat("assigned_material_amount")}
                                />
                                <div className="common-form-field-floating-label">{
                                    assignedActivityMaterial ?
                                        assignedActivityMaterial.measurement_unit + 's' :
                                        ''
                                }</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="common-form-body-row notes-row">
                <div className="common-form-body-row-horizontal">
                    <div className="common-form-body-row-horizontal-cell">
                        <div className={getABAFormFieldClasses("common-form-field", "notes")}>
                            <div className="common-form-field-label">
                                Foreman Notes
                            </div>
                            <div className="common-form-field-input-container">
                                <textarea
                                    id="notes"
                                    className="common-form-input"
                                    placeholder="Add notes for the foreman"
                                    value={activityBrokerAssignment.notes || ''}
                                    onChange={(event) => onChangeActivityBrokerAssignmentValue("notes", event.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="common-form-body-row-horizontal-cell">
                        <div className={getABAFormFieldClasses("common-form-field", "broker_notes")}>
                            <div className="common-form-field-label">
                                Broker Notes
                            </div>
                            <div className="common-form-field-input-container">
                                <textarea
                                    id="broker_notes"
                                    className="common-form-input"
                                    placeholder="Add notes for the broker"
                                    value={activityBrokerAssignment.broker_notes || ''}
                                    onChange={(event) => onChangeActivityBrokerAssignmentValue("broker_notes", event.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
